import { ComputeProviderName } from '@clovyr/pollen';
import { allHosts } from '@clovyr/pollen/fixtures/hosts';
import { sleep } from '@clovyr/pollen/util/sleep';

const initialProvider = 'AWS';

export const useCloudType = (el: Ref<HTMLElement | null>) => {
  const cloudName = ref(initialProvider);

  const providers: string[] = allHosts
    .filter((h) => h.id !== ComputeProviderName.AWSEC2)
    .map((h) => h.title);

  providers.unshift(initialProvider);

  let cloudIdx = 0;

  async function typeOut(str: string) {
    for (let i = 0; i <= str.length; i++) {
      cloudName.value = str.substring(0, i);
      // eslint-disable-next-line no-await-in-loop
      await sleep(30);
    }
  }

  let cloudTimer: NodeJS.Timeout | null = null;

  function startTimer() {
    if (cloudTimer) {
      return;
    }
    cloudTimer = setInterval(() => {
      cloudIdx++;
      if (cloudIdx > providers.length - 1) {
        cloudIdx = 0;
      }
      void typeOut(providers[cloudIdx]);
    }, 3000);
  }

  function stopTimer() {
    if (cloudTimer) {
      clearInterval(cloudTimer);
      cloudTimer = null;
    }
  }

  if (typeof IntersectionObserver === 'undefined') {
    return {
      cloudName: initialProvider,
    };
  }

  const visibilityObserver = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      // el is visible
      startTimer();
    } else {
      stopTimer();
    }
  });

  onBeforeUnmount(() => {
    stopTimer();
    visibilityObserver.disconnect();
  });

  if (el.value) {
    visibilityObserver.observe(el.value);
  } else {
    watch(
      el,
      (newValue) => {
        if (newValue) {
          visibilityObserver.observe(newValue);
        }
      },
      { once: true },
    );
  }

  return {
    cloudName,
  };
};
